export default __webpack_public_path__ + "static/media/adhyanshala-01.96348a69.jpg";